import React from 'react'
import { Wrapper, Title } from './style'

const Intro = props => 
  <Wrapper {...props} >
    <Title>
     Hiran Patel
    </Title>
  </Wrapper>

export default Intro
